import { api } from "../api";

export interface ItemStatus {
  code: string;
  label: string;
  isBorrowable: boolean;
  isVisibleInOPAC: boolean;
  affectsInventory: boolean;
  systemControlled: boolean;
  createdAt: string;
  updatedAt: string;
}

export const itemStatusesApi = {
  /**
   * Get all item statuses (read-only, system-defined)
   */
  getAll: async (): Promise<ItemStatus[]> => {
    const response = await api.get("/item-statuses");
    return response.data;
  },

  /**
   * Get all borrowable item statuses
   */
  getBorrowable: async (): Promise<ItemStatus[]> => {
    const response = await api.get("/item-statuses/borrowable");
    return response.data;
  },

  /**
   * Get all statuses visible in OPAC
   */
  getVisibleInOPAC: async (): Promise<ItemStatus[]> => {
    const response = await api.get("/item-statuses/visible-in-opac");
    return response.data;
  },

  /**
   * Get a single item status by code
   */
  getByCode: async (code: string): Promise<ItemStatus> => {
    const response = await api.get(`/item-statuses/${code}`);
    return response.data;
  },
};
